export default __webpack_public_path__ + "static/media/svg-3.c6625c0f.svg";